
import { useNavigate } from "react-router-dom";
import CreateArticleForm from "@/components/admin/CreateArticleForm";

const CreateArticle = () => {
  return (
    <div className="flex flex-col items-center pt-10 min-h-screen bg-gray-50">
      <CreateArticleForm />
    </div>
  );
};

export default CreateArticle;
